import { PAYMENT_ERRORS } from './Errors';

enum QUERY_PARAMS_KEYS {
  THREE_DS_BAD_CALL = '3ds-bad-call',
  THREE_DS_ERROR = '3ds-error',
  THREE_DS_NO_TRANS = '3ds-no-trans',
  CANNOT_PROCESS_ERROR = 'cannot-process-error',
  CART_CHANGED_ERROR = 'cart-changed-error',
  CART_EMPTY_ERROR = 'cart-empty-error',
  GENERIC_ERROR = 'generic-error',
  PAYMENT_PROVIDER_PROTOCOL_ERROR = 'payment-provider-protocol-error',
  REQUIRED_PRIVACY_POLICY_ERROR = 'required-privacy-policy-error',
  TRANSACTION_FAILED_ERROR = 'transaction-failed-error',
}

// Left argument: Query param name.
// Right argument: Error key that will be translated as the API_MESSAGE_KEY_TRANSLATIONS_MAP.
const paymentQueryParamsErrorsMapping = {
  [QUERY_PARAMS_KEYS.THREE_DS_BAD_CALL]: PAYMENT_ERRORS.THREE_DS,
  [QUERY_PARAMS_KEYS.THREE_DS_ERROR]: PAYMENT_ERRORS.THREE_DS,
  [QUERY_PARAMS_KEYS.THREE_DS_NO_TRANS]: PAYMENT_ERRORS.THREE_DS,
  [QUERY_PARAMS_KEYS.CANNOT_PROCESS_ERROR]: PAYMENT_ERRORS.CANNOT_PROCESS,
  [QUERY_PARAMS_KEYS.CART_CHANGED_ERROR]: PAYMENT_ERRORS.CART_CHANGED,
  [QUERY_PARAMS_KEYS.CART_EMPTY_ERROR]: PAYMENT_ERRORS.CART_EMPTY,
  [QUERY_PARAMS_KEYS.GENERIC_ERROR]: PAYMENT_ERRORS.GENERIC,
  [QUERY_PARAMS_KEYS.PAYMENT_PROVIDER_PROTOCOL_ERROR]: PAYMENT_ERRORS.PAYMENT_PROVIDER_PROTOCOL_ERROR,
  [QUERY_PARAMS_KEYS.REQUIRED_PRIVACY_POLICY_ERROR]: PAYMENT_ERRORS.REQUIRED_PRIVACY_POLICY,
  [QUERY_PARAMS_KEYS.TRANSACTION_FAILED_ERROR]: PAYMENT_ERRORS.TRANSACTION_FAILED,
};

// Left argument: Query param name.
// Right argument: Error key that will be translated as the API_MESSAGE_KEY_TRANSLATIONS_MAP.
const shippingQueryParamsErrorsMapping = {};

const queryParamsErrorsMapping = {
  ...paymentQueryParamsErrorsMapping,
  ...shippingQueryParamsErrorsMapping,
};

export {
  queryParamsErrorsMapping,
  paymentQueryParamsErrorsMapping,
  shippingQueryParamsErrorsMapping,
  QUERY_PARAMS_KEYS,
};
